import { css } from '@emotion/css';
import {
  Container,
  Tabs,
} from '@mantine/core';

import { RouteNamesType, routes } from '^/userWeb/routes';

import './HeaderTabs.css';

const tabs = [
  {
    ko: '카메라 관리',
    route: routes.adminCamerasPage.name,
  },
  {
    ko: '사용자 관리',
    route: routes.adminUsersPage.name,
  },
  {
    ko: 'iot 기기 관리',
    route: routes.adminIotPage.name,
  },
] as const;

/**
 * @link https://ui.mantine.dev/category/headers/#header-tabs
 */
export function AdminHeaderTabs({
  routeName,
  isAdmin,
}: {
  isAdmin: boolean;
  routeName: RouteNamesType;
}) {
  const items = tabs.map((tab) => (
    <Tabs.Tab
      value={tab.route} key={tab.route} onClick={() => {
        switch (tab.ko) {
          case 'iot 기기 관리':
            routes
              .adminIotPage()
              .push();
            break;
          case '사용자 관리':
            routes
              .adminUsersPage()
              .push();
            break;
          case '카메라 관리':
            routes
              .adminCamerasPage()
              .push();
            break;
          default:
            throw Error('tab을 설정해 주세요.');
        }
      }}
    >
      {tab.ko}
    </Tabs.Tab>
  ));

  if (!isAdmin) {
    return null;
  }

  return (
    <div className="header">
      <Container size="xxl">
        <span
          className={css`
            float: left;
            padding-top: 12px;
            padding-right: 12px;
          `}
        >
          관리자메뉴:
        </span>
        <Tabs
          key={routeName}
          defaultValue={routeName}
          variant="default"
          // visibleFrom="sm"
          classNames={{
            root: 'tabs',
            list: 'tabsList',
            tab: 'tab',
          }}
          color="teal"
        >
          <Tabs.List>
            {items}
          </Tabs.List>
        </Tabs>
      </Container>
    </div>
  );
}
